// Admin-published, product-wide guidance file (backend Document with scope
// ProductResource). Shared by the Document Hub (admin), the on-site checklist
// step tiles, and the read-only Guidance section of the Documents tab.
export interface ProductResource {
  id: number;
  targetProduct: number;
  targetStep: number | null; // canonical checklist step (meta.number); null = general
  // Stable step identity, unaffected if steps are ever inserted/removed. Null on
  // "Documents tab" files and on rows the backend has not backfilled yet.
  targetStepKey: string | null;
  // Admin-set display position within its (product, step) group. Null sorts last.
  sortOrder: number | null;
  title: string | null;
  language: string | null;
  originalName: string;
  contentType: string;
  sizeBytes: number;
  createdAt: string;
}

export function isVideoResource(r: ProductResource): boolean {
  return r.contentType.startsWith('video/');
}

export function isImageResource(r: ProductResource): boolean {
  return r.contentType.startsWith('image/');
}
